import { Alert, Container, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import {
    CONTACT_VERIFICATION_EMAIL_KEY,
    CONTACT_VERIFICATION_IDENTITY_DATA_KEY,
    CONTACT_VERIFICATION_PHONE_KEY,
    getItemFromLS,
    useContactVerificationData,
} from '../../core/api'
import VerificationIdentityFormCard from './VerificationIdentityFormCard'

export default function VerificationIdentityEditCard() {
    const { t } = useTranslation()
    const { data, isPending, error } = useContactVerificationData(true)
    const identityData = getItemFromLS(CONTACT_VERIFICATION_IDENTITY_DATA_KEY) || {}

    if (isPending) {
        return (
            <Container maxWidth="sm" sx={{ py: { xs: 3, md: 5 }, flexGrow: 1 }}>
                <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 } }}>
                    <Typography color="text.secondary">{t('verification.reviewLoading')}</Typography>
                </Paper>
            </Container>
        )
    }

    if (error || !data) {
        return (
            <Container maxWidth="sm" sx={{ py: { xs: 3, md: 5 }, flexGrow: 1 }}>
                <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 } }}>
                    <Alert severity="error">{error?.response?.data?.message || error?.message || t('verification.reviewError')}</Alert>
                </Paper>
            </Container>
        )
    }

    return (
        <VerificationIdentityFormCard
            title={t('verification.editIdentityDataTitle')}
            description={t('verification.editIdentityDataDescription')}
            initialValues={{
                vat: identityData.vat || data.vat || '',
                name: identityData.name || data.name || '',
                org: identityData.org || data.org || '',
                commercialRegistrationQueryCode:
                    identityData.commercialRegistrationQueryCode || data.commercialRegistrationQueryCode || '',
                street: identityData.street || data.street || '',
                city: identityData.city || data.city || '',
                zipcode: identityData.zipcode || data.zipcode || '',
                country: identityData.country || data.country || '',
            }}
            email={data.email || getItemFromLS(CONTACT_VERIFICATION_EMAIL_KEY) || ''}
            phone={data.phone || data.mobile || getItemFromLS(CONTACT_VERIFICATION_PHONE_KEY) || ''}
        />
    )
}
